export class ListJobErrorCodesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "errorCodes",
            "baseName": "errorCodes",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListJobErrorCodesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
